<ng-container *ngIf="items">
  <div class="params-top">
    <span class="params-top-button-container">
      <u-icon (click)="goBack()" class="clickable params-top-button" [model]="{ type: 'font', value: 'icon-chevron-left' }"></u-icon>
    </span>
    <div class="params-top-text" *ngIf="text">{{ text }}</div>
  </div>

  <ng-scrollbar class="virtual-scroll" visibility="hover">
    <cdk-virtual-scroll-viewport
      [itemHeights]="itemHeights || []"
      customVirtualScrollStrategy
      ngScrollbarView
      smoothScroll
      scrollViewport
      [class.virtual-scroll]="true"
    >
      <ng-container *cdkVirtualFor="let item of items; index as i; trackBy: trackResult">
        <param-selections-item
          [class.selected]="selectedIndex === i"
          [selected]="selectedIndex === i"
          [model]="item"
          [index]="i"
          (click)="selectedIndex = i; onItemClick(i)"
          (invoke)="selectedIndex = i; onItemClick(i)"
          class="params-item"
        ></param-selections-item>
      </ng-container>
    </cdk-virtual-scroll-viewport>
  </ng-scrollbar>
</ng-container>

<ng-template #splited>
  <result-header [title]="'HIGHLIGHTS'"></result-header>
  <ng-container *cdkVirtualFor="let item of highlights; index as i; trackBy: trackResult">
    <param-selections-item
      [class.selected]="selectedIndex === i"
      [selected]="selectedIndex === i"
      [model]="item"
      [index]="i"
      (click)="selectedIndex = i; onItemClick(i)"
    ></param-selections-item>
  </ng-container>

  <result-header [title]="'ALL'"></result-header>
  <ng-container *cdkVirtualFor="let item of recency; index as i; trackBy: trackResult">
    <param-selections-item
      [class.selected]="selectedIndex === i + highlights.length"
      [selected]="selectedIndex === i + highlights.length"
      [model]="item"
      [index]="i + highlights.length"
      (click)="selectedIndex = i + highlights.length; onItemClick(i + highlights.length)"
    ></param-selections-item>
  </ng-container>
</ng-template>
